<template>
  <div>
    <label :for="id" class="label">
      {{ label || $texts('search.searchFieldLabel') }}
    </label>
    <div
      class="relative flex gap-16"
      role="search"
      :aria-label="label || $texts('search.searchFieldLabel', 'Suchbegriff')"
    >
      <input
        :id="id"
        v-model.lazy="value"
        type="search"
        autocomplete="off"
        name="searchterm"
        class="input flex-1"
        spellcheck="false"
        :placeholder="
          $texts('enterSearchTerm')
        "
      />

      <button type="submit" class="button is-primary">
        <SpriteSymbol name="search" />
        <span class="sr-only md:not-sr-only">
          {{ $texts('submitSearch') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  id: string
  label?: string
}>()

const value = defineModel<string>()
</script>
